import { render } from "./LOBody.vue?vue&type=template&id=7d9ecb9c&scoped=true"
import script from "./LOBody.vue?vue&type=script&lang=js"
export * from "./LOBody.vue?vue&type=script&lang=js"

import "./LOBody.vue?vue&type=style&index=0&id=7d9ecb9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9ecb9c"]])

export default __exports__